import PublicAgreementPage, { TYPE_IDS } from "./PublicAgreementPage";

export default function Terms() {
  return (
    <PublicAgreementPage
      typeId={TYPE_IDS.TermsOfService}
      fallbackTitle="Terms of Service"
      fallbackLead="These terms govern your use of CareerMaster, including optional SMS messaging for account verification and alerts."
    />
  );
}
